function ContentParagraph(props) {
  return (
    <p className="py-5">{props.children}</p>
  );
}

export default ContentParagraph;
